import { CONTENT_VERTICAL_ALIGNMENT } from '@app/core/cms-flex/types';

import { ContentVerticalAlignment } from '../types';

export const CONTENT_ALIGNMENT = new Map<CONTENT_VERTICAL_ALIGNMENT, ContentVerticalAlignment>()
  .set(CONTENT_VERTICAL_ALIGNMENT.TOP, 'content-top')
  .set(CONTENT_VERTICAL_ALIGNMENT.MIDDLE, 'content-center')
  .set(CONTENT_VERTICAL_ALIGNMENT.BOTTOM, 'content-bottom');
